import React, { useEffect, useState } from 'react';
import UserHelper from '../../common/utils/userHelper';
import axios from 'axios';
import { API_GATEWAY_URL } from '../../config/constants';

const FAQ: React.FC = () => {

  const eventId = UserHelper.getEventId();
  const [data, setData] = useState<any>();

  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        const res = await axios.get(`${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}/faq`);
        console.log('Faq page data:', res.data.data);
        setData(res.data.data);
      } catch (error) {
        console.error('Error fetching faq page data:', error);
      }
    };

    fetchFaqData();
  }, [eventId]);

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }
  
  return (
    // <!--FAQ section-->
    <div className="single-section silver-bg" id="faq">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* <!--section heading--> */}
            <div className="section-heading">
              <h2 className="section-title">Frequently Asked Questions</h2>
              <p className="section-description col-lg-8 col-md-10 col-sm-12">
                Everything you need to know about the event and participation.
              </p>
            </div>
            {/* <!--section heading ends!--> */}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12">
            {data?.map((faq:any, index:any) => (
              <div key={index} className="faq-item mb-3 border-bottom pb-3">
                <div
                  className="d-flex justify-content-between align-items-center cursor-pointer"
                  onClick={() => toggleFAQ(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <h5 className="mb-0">{faq.question}</h5>
                  <span>{activeIndex === index ? '▲' : '▼'}</span>
                </div>
                {activeIndex === index && (
                  <p className="mt-2 text-muted">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    // <!--FAQ section ends-->
  );
};

export default FAQ;
